import React from "react";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

const LegalDisclaimer: React.FC = () => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="center"
      textAlign="center"
      sx={{ mt: 3 }}
    >
      <Typography sx={{ mr: 0.5 }} variant="subtitle2" color="grey700">
        Продовжуючи, я погоджуюсь з умовами{" "}
        <Link href="/public-offer" target="_blank" color="primary.main">
          Публічної оферти
        </Link>{" "}
        та{" "}
        <Link href="/terms-of-service" target="_blank" color="primary.main">
          Політики конфіденційності
        </Link>
      </Typography>
    </Box>
  );
};

export default LegalDisclaimer;
